<template>
  <div class="l-edit-dialog-box">
    <div class="l-table-place">
        <div class="flex flex-warp">
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">编码</p>
            <el-input
              placeholder="请输入编码"
              v-model="search_data.material_code"
              class="input-with-select"
              style="width: 80%;"
            >
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
          </div>
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">名称</p>
            <el-input
              placeholder="请输入名称"
              v-model="search_data.name"
              class="input-with-select"
              style="width: 80%;"
            >
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
          </div>
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">分类名</p>
            <el-cascader v-model="search_data.type_id" :options="type_node" :props="{ checkStrictly: true }" clearable style="width:500px;"/>
            </el-cascader>
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </div>
    
        </div>    
          
    </div> 
    
    <div>
      <l-auth-button type="primary" auth="cabinet_template_detail_add_btn" @click="add_visible = true"> 新增</l-auth-button>
    </div>
    
    <l-table :data="data" v-loading="loading" row-key="id">
    
      <!-- <el-table-column prop="place_type_name" label="归属场所类型" min-width="80"></el-table-column> -->
    
      <el-table-column prop="material_code" label="编码" min-width="80">
      </el-table-column>
      <el-table-column prop="material_name" label="名称" min-width="200">
      </el-table-column>
      <el-table-column prop="abbreviation" label="缩写" min-width="80"> </el-table-column>
      <el-table-column prop="specification_name" label="规格" min-width="80"> </el-table-column>
      <el-table-column prop="material_quantity" label="投放数量" min-width="80"> 
        <template slot-scope="{ row }">
            <el-input v-model="row.material_quantity" autocomplete="off" placeholder="请输入数量" 
                v-show="row.show" />
            <span v-show="!row.show">{{row.material_quantity}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="material_sku_name" label="库存单位" min-width="80"> </el-table-column>
      
      <!-- <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column> -->
      <el-table-column fixed="right" label="操作" width="350" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="cabinet_template_detail_edit_btn" @click="edit(row,'edit')" v-show="!row.show">
              <i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <l-auth-text-button type="primary" auth="cabinet_template_detail_edit_btn" @click="edit(row,'save')" v-show="row.show">
              <i class="el-icon-edit"></i>保存</l-auth-text-button>
          <l-auth-text-button type="primary" auth="cabinet_template_detail_edit_btn" @click="edit(row,'cancel')" v-show="row.show">
              <i class="el-icon-edit"></i>取消</l-auth-text-button>
          <!-- <el-button @click="row.show=false">保存</el-button> -->
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="cabinet_template_detail_del_btn" @click="del(row.id)">
              <i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>

    </l-table>
    <!--添加模板柜物资-->
    <l-dialog :visible.sync="add_visible" title="添加模板柜物资" width="1000px">
      <l-template-material-edit @on-success="onAddSucess" :visible.sync="add_visible" :id="this.$props.id"></l-template-material-edit>
    </l-dialog>
  </div>

    

</template>

<script>
import {
  types
} from './lavel.js';
import TemplateMaterialEdit from "./TemplateMaterialEdit.vue";
// console.log(types)
export default {
  name: 'l-material-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    // place_type: {
    //   type: [String, Number],
    //   default: null
    // },
    material_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
    [TemplateMaterialEdit.name]: TemplateMaterialEdit,
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list() {
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    // "form_data.pid"() {
    //   if (!this.getdata_flag) {
    //     this.form_data.type = ""
    //   } else {
    //     this.getdata_flag = false
    //   }
    //   this.changes();
    // }
  },
  data() {
    return {
        data: [],
        count: 0,
      loading: false,//页面是否加载中
      getdata_flag: false,
      LAVEL_LIST: types,
      //是否显示
      type_node: [

      ],
      material_sku_list: [],
      //表单数据
      form_data: {
        // is_node: 0,
        // pid: "",
        material_name: '',
        material_code: '',
        // department_level: '',
        abbreviation: '',
        // place_type: '',
        // is_public: 1,
      },
      nodeList: [],
      material_list: [],
      specification_list: [],
      //分类
      sel_type_id: "",
      type_name: "",
      material_id: 0,
      add_visible: false, //是否显示添加
      search_data: {
        keywords: "",
        material_code: "",
        name: "",
        type_id: [],
      },
      //表单验证规则
      rules: {
        // type_id: [
        //   { required: true, message: '器材分类不能为空', trigger: 'change' }
        // ],
        // material_name: [
        //   { required: true, message: '名称不能为空', trigger: 'change' }
        // ],
        // material_quantity: [
        //   { required: true, message: '投放数量不能为空', trigger: 'change' }
        // ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // changes() {
    //   this.$_invoke("industry_getData", {
    //     type: this.form_data.type
    //   }).then((ret) => {  
    //     this.nodeList = ret.data
    //   })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    
    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },
    
    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },
    
    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getData();
    },

    //获取数据
    getData() {
//       this.$_invoke(`cabinetTemplate_saveData`, ).then((ret) => {
// console.log(ret);
//         this.tree_node = ret.tree_node;
//       }).finally(() => {
//         this.loading = false;
//       });
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`cabinetTemplate_getMaterialList`, { id: this.$props.id }).then((ret) => {
            this.data = ret.data;
            this.count = ret.count;
          // this.form_data = ret.data;
          this.type_node = ret.type_node;
          // this.material_sku_list = ret.material_sku_list;
          this.getdata_flag = true
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // this.form_data.use_type = this.$props.useType
      }

    },

    // changeMaterialType(typeid) {
    //     console.log(typeid);
    //     let sel_type_id = typeid
    //     if (typeof sel_type_id != "number") {
    //       const pid_len = sel_type_id.length;
    //       sel_type_id = sel_type_id[pid_len - 1];
    //     }
        
    //     this.loading = true;
    //     this.$_invoke(`cabinetTemplate_getMaterialListByTypeId`, {sel_type_id }).then((ret) => {
    //         this.material_list = ret.material_list;
    //     }).finally(() => {
    //       this.loading = false;
    //     });
    // },
    
    // changeMaterial(materialname) {
    //     console.log(materialname);
    //     let sel_material_name = materialname
        
    //     this.loading = true;
    //     this.$_invoke(`cabinetTemplate_getSpecificationListByMaterialName`, {sel_material_name }).then((ret) => {
    //         this.specification_list = ret.specification_list;
    //     }).finally(() => {
    //       this.loading = false;
    //     });
    // },

    // changeSpecification(materialname,specificationid) {
    //     let sel_material_name = materialname
    //     let sel_specification_id = specificationid
    //     this.loading = true;
    //     this.$_invoke(`cabinetTemplate_getMaterialIdByMaterialNSpecification`, {sel_material_name,sel_specification_id })
    //         .then((ret) => {
    //             this.material_id = ret.material_id;
    //         })
    //         .finally(() => {
    //             this.loading = false;
    //         });
    // },

    //提交数据
    // handleSubmit() {
    //   if (this.loading) return;
    //   this.$refs.form.validate((valid) => {

    //     if (valid) {
    //       // let form_data = Object.assign({}, this.form_data);
    //       // if (typeof form_data.pid != "number") {
    //       //   const pid_len = form_data.pid.length;
    //       //   form_data.pid = form_data.pid[pid_len - 1];
    //       // }
    //       this.submitting = true;
    //       // this.form_data.place_type = 3;
    //       if (this.hasId) {//添加
    //         this.$_invoke('cabinetTemplate_saveMaterial', {material_id:this.material_id, id:this.$props.id, material_quantity:this.form_data.material_quantity}).then(() => {
    //           this.$_msg.success('添加消防器材成功');
    //           this.getData();
    //         }).finally(() => {
    //           this.submitting = false;
    //         })
    //       } else {//修改
            
    //       }
    //     }
    //   })

    // },
    
    //编辑/保存，改变状态
    edit(row, mode) {
        console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }
    
        //save
        if (mode == "save") {
            this.submitting = true;
            if (this.hasId) {
                this.$_invoke('cabinetTemplate_updateMaterial', {id: row.id, 
                                                                material_quantity: row.material_quantity, 
                                                                producted_at: row.producted_at})
                    .then(() => {
                this.$_msg.success('修改消防器材成功');
                this.getData();
              }).finally(() => {
                this.submitting = false;
              })
            }
        }
    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`cabinetTemplate_deleteMaterial`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getData();
            }
          });
        })
        .catch(() => { });
    },
    
  },
}
</script>